import React from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getVehicleCreateAdPath, getVehicleVertical } from 'lib/utils/store/vehicle'
import { UTM_CAMPAIGN, UTM_CONTENT } from 'lib/utm'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'

const CreateAdSketchButton = ({ text, vehicle, className, to, isSpecialSuccessCase, isVerifiedAd }) => {
    const { t, i18n } = useTranslation(['vehicles'])

    const vertical = getVehicleVertical(vehicle)

    text = text || t(`vehicles:actions.createAdIn.${vertical}.linkText`)
    const stateForVerifiedAd = !to && { isSpecialSuccessCase: isSpecialSuccessCase, isVerifiedAd: isVerifiedAd }

    return (
        <Link
            className={className}
            to={to || `${getLocale(i18n.language)}${getVehicleCreateAdPath(vehicle.id)}`}
            trackName="createAd"
            utmTag={{
                campaign: UTM_CAMPAIGN.HALLINNOI,
                content: UTM_CONTENT.MYY,
            }}
            state={stateForVerifiedAd}
            target="_self"
        >
            {text}
        </Link>
    )
}

CreateAdSketchButton.propTypes = {
    vehicle: PropTypes.object.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
)(CreateAdSketchButton)
